<!--
 * @Author: xiaohe
 * @LastEditors: xiaohe
-->
<template>
  <div class="payInfo">
    <PlateTitle title="投保信息" />
    <div class="main">
      <a-form :label-col="{ span: 10 }" :wrapper-col="{ span: 12}">
        <a-row>
          <a-col :span="12">
            <a-form-item label="业务流水号" has-feedback>
              <span>{{ infoJson.orderCode }}</span>
            </a-form-item>
          </a-col>
          <a-col :span="12">
            <a-form-item label="投标企业名称" has-feedback>
              <span>{{ infoJson.enterpriseName }}</span>
            </a-form-item>
          </a-col>
        </a-row>
        <a-row>
          <a-col :span="12">
            <a-form-item label="订单时间" has-feedback>
              <span>{{ dateFormat(infoJson.createTime) }}</span>
            </a-form-item>
          </a-col>
          <a-col :span="12">
            <a-form-item label="项目名称" has-feedback>
              <span>{{ infoJson.projectName }}</span>
            </a-form-item>
          </a-col>
        </a-row>
        <a-row>
          <a-col :span="12">
            <a-form-item label="标段名称" has-feedback>
              <span>{{ infoJson.sectionName }}</span>
            </a-form-item>
          </a-col>
          <a-col :span="12">
            <a-form-item label="标段编号" has-feedback>
              <span>{{ infoJson.sectionCode }}</span>
            </a-form-item>
          </a-col>
        </a-row>
       
        <a-row>
          <a-col :span="12" >
            <a-form-item label="担保金额(元)" has-feedback>
              <span class="blue">{{ thousandCentimeter(infoJson.sumAmount) }}</span>
            </a-form-item>
          </a-col>
          <a-col :span="12" >
            <a-form-item label="保证金金额(元)" has-feedback>
              <span class="blue">{{ thousandCentimeter(infoJson.sumMargin) }}</span>
            </a-form-item>
          </a-col>
        </a-row>
        <a-row>
          <a-col :span="12" class="blue">
            <a-form-item label="保费金额(元)" has-feedback>
              <span class="blue">{{ thousandCentimeter(infoJson.sumPremium) }}</span>
            </a-form-item>
          </a-col>
        </a-row>
      </a-form>
    </div>
    <PlateTitle title="收款信息" />
    <div class="main">
      <a-form :label-col="{ span: 10 }" :wrapper-col="{ span: 12}">
        <a-row>
          <a-col :span="12">
            <a-form-item label="账号名称" has-feedback>
              <span>{{ infoJson.payOfflineAccountName}}</span>
            </a-form-item>
          </a-col>
          <a-col :span="12">
            <a-form-item label="收款开户" has-feedback>
              <span>{{ infoJson.payOfflineAccountNumber }}</span>
            </a-form-item>
          </a-col>
        </a-row>
        <a-row>
          <a-col :span="12">
            <a-form-item label="开户行名称" has-feedback>
              <span>{{ infoJson.payOfflineOpenBank }}</span>
            </a-form-item>
          </a-col>
          <a-col :span="12">
            <a-form-item label="开户行行号" has-feedback>
              <span>{{ infoJson.payOfflineLineNumber }}</span>
            </a-form-item>
          </a-col>
        </a-row>
        <!-- <a-row>
          <a-col :span="12">
            <a-form-item label="金额(元)" has-feedback>
              <span>{{ infoJson.sumPremium }}</span>
            </a-form-item>
          </a-col>
        </a-row> -->
      </a-form>
    </div>
    <PlateTitle title="保证金支付" v-if="infoJson.sumMargin"/>
    <div class="main" v-if="infoJson.sumMargin">
      <p class="Pending">待支付金额：<span>￥{{thousandCentimeter(infoJson.sumMargin)}}</span> 元</p>

      <div class="upload">
        <a-upload
          :accept="accept"
          :beforeUpload="beforeUpload"
          @change="handleChange"
        >
        <!-- 
           -->
          <a-button> <a-icon type="upload" /> 上传文件 </a-button>
        </a-upload>
        <div class="limt">(支持jpg、png格式文件，文件不能大于5M)</div>
        <div class="tips">
          <p>1、请贵司使用企业对公账户缴纳保证金，转账后请务必在支付页面上传支付凭证，如未按照要求操作会导致保函购买失效； </p>
          <p>2、打款时，请务必告知财务人员，在打款备注填写“转账”或“保证金”，填写打款备注时注意不要填写其他无关信息；</p>
        </div>
      </div>
    </div>
    <PlateTitle title="保费缴纳" />
    <div class="main">
      <p class="Pending">待支付金额：<span>￥{{thousandCentimeter(infoJson.sumPremium)}}</span> 元</p>
      <div class="upload">
        <a-upload
          :accept="accept"
          name="file"
          :beforeUpload="beforeUpload"
          @change="handleChange2"
        >
          <a-button> <a-icon type="upload" /> 上传文件 </a-button>
        </a-upload>
        <div class="limt">(支持jpg、png格式文件，文件不能大于5M)</div>
        
        <div class="tips">
          <p>1、保费收费账户信息与保证金收款账户信息不一致，请勿转错账户； </p>
          <p>2、转账后请务必在支付页面上传支付凭证，如未按要求操作会导致保函购买失效； </p>
          <p>3、请贵司务必使用企业对公账户缴纳保费；</p>
        </div>
      </div>
    </div>
    <div v-if="isShow" class="submitBtn" @click="submitFun">确认提交</div>
    <div v-else class="gry " >支付审核中....</div>
  </div>
</template>
<script>
import PlateTitle from "@/components/PlateTitle";
import { getPaymentInfo, offlinePost } from "./api.js";
import UloadBtn from "@/components/UploadBtn/uloadBtn.vue";
import { dateFormat } from '@/utils/format.js';
export default {
  components: {
    PlateTitle,
    UloadBtn
  },
  data() {
    return {
      dateFormat,
      infoJson: {},
      orderCode: "",
      fileData: [],
      uploadAction: process.env.VUE_APP_FIRST_URL + '/api/contract/upload',
      fileInfo:{},
      isShow: false,
      fileList1:[],
      fileList2:[],
      accept: ".png,.jpg",
    };
  },
  mounted() {
    this.init();
    this.orderCode = this.getQueryString("orderCode");
  },
  methods: {
    thousandCentimeter(value){
      if (!value) return '0.00';
      return value.toFixed(2).replace(/\d(?=(\d{3})+\.)/g, '$&,');
    },
    beforeUpload(file) {
      return false;
    },
    handleChange(file) {
      this.fileList1 = file.fileList
    },
    handleChange2(file) {
      this.fileList2 = file.fileList
    },
    
    getQueryString(name) {
      const reg = new RegExp("(^|&)" + name + "=([^&]*)(&|$)");
      const r = window.location.search.substr(1).match(reg);
      if (r != null) return unescape(r[2]);
      return null;
    },
    async init() {
      this.orderCode = this.getQueryString("orderCode");
      const { data: data } = await getPaymentInfo({
        orderCode: this.orderCode,
      });
      this.infoJson = data;
      if(this.infoJson.payEnable) {
        this.isShow = true
      }
      // if(this.infoJson.vouchStatus === "0" || this.infoJson.vouchStatus === "3") {
      //   this.isShow = true
      // }
      // if(this.infoJson.vouchStatus === "2") {
      //   window.location.href = this.infoJson.backUrl;
      // }
    },
    submitFun() {
      if(!this.fileList1.length &&this.infoJson.sumMargin&&this.infoJson.sumMargin>0){
        this.$message.error(`请上传保证金支付凭证`);
        return 
      }
      if(!this.fileList2.length){
        this.$message.error(`请上传保费支付凭证`);
        return 
      }
      document.getElementById('uploadForm')
      const formData = new FormData()
      formData.append('orderCode', this.infoJson.orderCode)
      if(this.fileList1.length){
        this.fileList1.map(item=>{
          formData.append('marginVoucher', item.originFileObj)
        })
      }
      this.fileList2.map(item=>{
          formData.append('premiumVoucher', item.originFileObj)
        })
      offlinePost(formData).then((res) => {
        if (res.status == 200) {
          this.$message.success('提交成功，请等待审核');
          this.$router.push({ path: '/nonBidInsure', query: { orderCode: this.infoJson.orderCode } })
        }
        // if (res.data.status == 200) {
        //   window.location.href = this.infoJson.backUrl;
        // } else {
        //   this.$message.error(res.data.message);
        // }
      });
      // if(this.fileData.length === 0) {
      //   this.$message.error(`请上传打款凭证`);
      // } else {
      //   const data = {
      //     orderCode: this.orderCode,
      //     fileInfo: this.fileData[0].response.data
      //   }
      //   offlinePost(data).then((res) => {
      //     if (res.data.status == 200) {
      //       window.location.href = this.infoJson.backUrl;
      //     } else {
      //       this.$message.error(res.data.message);
      //     }
      //   });
      // }
    }
  },
};
</script>

<style lang="less" scoped>
.payInfo {
  width: 1200px;
  min-height: 700px;
  background: #ffffff;
  box-shadow: 0px 4px 4px 0px rgba(0, 124, 226, 0.03);
  border-radius: 2px 2px 2px 2px;
  margin: auto;
  margin-top: 24px;
  margin-bottom: 24px;
  padding: 40px 30px 80px 30px;
  .subtitle {
    font-size: 14px;
    line-height: 28px;
  }
  ::v-deep .ant-form-item-label {
    width: 192px;
    padding-left: 24px;
    font-size: 16px;
    font-family: Microsoft YaHei-Regular, Microsoft YaHei;
    font-weight: 400;
    color: #333333;
    margin-right: 10px;
  }
  ::v-deep .ant-form-item-children {
    font-size: 16px;
    font-family: Microsoft YaHei-Regular, Microsoft YaHei;
    font-weight: 400;
    color: #666666;
  }
  /deep/ .ant-form-item {
    margin-bottom: 10px !important;
  }
  .main {
    margin-top: 20px;
    margin-bottom: 30px;
  }
  .pay_info {
    display: flex;
    margin-left: 80px;
    .info_box {
      width: 380px;
      height: 400px;
      background: #ffffff;
      box-shadow: 5px 15px 30px 5px rgba(75, 111, 158, 0.15);
      border-radius: 5px 5px 5px 5px;
      margin-right: 20px;
      cursor: pointer;
      .head_s {
        padding-top: 40px;
        text-align: center;
        font-size: 18px;
        font-family: Source Han Sans CN-Medium, Source Han Sans CN;
        font-weight: 500;
        color: #333333;
      }
      .logo {
        margin: auto;
        width: 150px;
        height: 150px;
        margin-top: 33px;
        img {
          width: 150px;
          height: 150px;
        }
      }
    }
    .pay {
      display: flex;
      width: 160px;
      height: 60px;
      border: 1px solid #ccc;
      border-radius: 8px;
      margin-right: 20px;
      cursor: pointer;
      position: relative;
      .payImg {
        width: 120px;
        height: 40px;
        position: relative;
        top: 10px;
        left: 15px;
      }
      .choose {
        width: 16px;
        height: 16px;
        position: absolute;
        top: 3px;
        right: 3px;
        z-index: 2;
      }
    }
    .active {
      border-color: #0E52D4;
    }
  }
  .submitBtn {
    width: 160px;
    height: 35px;
    text-align: center;
    line-height: 35px;
    background: #0E52D4;
    color: #ffffff;
    border-radius: 5px;
    margin: 40px auto 0;
    cursor: pointer;
  }
  .gry {
    width: 160px;
    height: 35px;
    text-align: center;
    line-height: 35px;
    background: #28292a;
    color: #ffffff;
    border-radius: 5px;
    margin: 40px auto 0;
  }
  .upload {
    width: 500px;
    margin: 30px auto 0;
    position: relative;
  }
  .tips {
    margin-top: 30px;
    p {
      color: #333;
      font-size: 12px;
    }
  }
  .limt {
    position: absolute;
    top: 7px;
    left: 120px;
    font-size: 12px;
  }
}
.wxTips {
  color: red;
  padding: 30px;
}
.blue{
  color: #125AFF!important;
  font-weight: 500;
  font-size: 20px;
}
.Pending{
  font-family: PingFang SC, PingFang SC;
  font-weight: 500;
  font-size: 20px;
  color: rgba(0,0,0,0.9);
  line-height: 28px;
  text-align: left;
  font-style: normal;
  text-transform: none;
  width: 500px;
  margin: 0 auto;
}
.Pending span{
  color: #125AFF;
}

</style>
